module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"open":"Offen","invited":"Eingeladen","accepted":"Akzeptiert","declined":"Abgelehnt"},"en":{"open":"Open","invited":"Invited","accepted":"Accepted","declined":"Declined"}}')
  delete Component.options._Ctor
}
